import * as React from 'react';

export const DrawButtonNew = ({ active }: { active: boolean }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.52543 0C5.1598 0 4.05273 1.10706 4.05273 2.4727V8.38197L3.63632 8.17376C1.98989 7.35055 0.0527344 8.54778 0.0527344 10.3885C0.0527344 11.0453 0.313618 11.6751 0.777995 12.1395L4.64084 16.0023L12.8685 16L14.5437 9.18063C14.9412 7.57275 13.9605 5.94692 12.3528 5.54862L8.99813 4.71751V2.4727C8.99813 1.10706 7.89107 0 6.52543 0ZM6.05273 2.4727C6.05273 2.21164 6.26437 2 6.52543 2C6.7865 2 6.99813 2.21164 6.99813 2.4727V6.28249L11.8719 7.48993C12.4078 7.6227 12.7347 8.16464 12.6022 8.7006L11.3006 14L5.46463 13.9977L2.19221 10.7253C2.1029 10.636 2.05273 10.5148 2.05273 10.3885C2.05273 10.0345 2.42527 9.8043 2.74189 9.96261L6.05273 11.618V2.4727Z"
        fill={active ? 'white' : '#212C46'}
      />
      <path
        d="M13.4114 1.29174C12.392 0.629347 11.235 0.208007 10.0284 0.0597241L9.78441 2.04479C10.6894 2.156 11.5571 2.47201 12.3217 2.9688C13.097 3.47259 13.7538 4.13833 14.1604 4.94851L15.948 4.05151C15.3509 2.8617 14.4201 1.94713 13.4114 1.29174Z"
        fill={active ? 'white' : '#212C46'}
      />
    </svg>
  );
};
